module.exports = __webpack_public_path__ + "assets/images/premium-features/multiple-applicants-07d7fd.png";